import request from '../utils/http'
// const appid = 0  // 不同小程序对接同一后台

// 获取商品权限管理 302
export function getShopConfig(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'view_aaa_enum_price',
            ...data
        }
    })
}

// 根据成本价计算溢价后的零售价 305
export function getShopCbPrice(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'computeprice',
            ...data
        }
    })
}

// 根据成本价计算溢价后的团购价 307
export function getShopTuanPrice(data) {
    return request({
        url: '/service/aaa.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'tuanprice',
            ...data
        }
    })
}